import * as HeroIconsSolid from '@heroicons/react/solid';
import React from 'react';
import { Text, TextType } from '../Text';
import { appendClassProps } from '../util';
import { PillVariant } from './index.types';
export const Pill = ({ variant = PillVariant.primary, children, className, color, leftIcon, rightIcon, propagateRightIconClickEvent, propagateLeftIconClickEvent, onClick, onClickLeftIcon, onClickRightIcon }) => {
    let LeftIcon;
    let RightIcon;
    if (leftIcon)
        LeftIcon = HeroIconsSolid[leftIcon];
    if (rightIcon)
        RightIcon = HeroIconsSolid[rightIcon];
    const handleClickRightIcon = (event) => {
        if (!propagateRightIconClickEvent)
            event.stopPropagation();
        if (onClickRightIcon)
            onClickRightIcon();
    };
    const handleClickLeftIcon = (event) => {
        if (!propagateLeftIconClickEvent)
            event.stopPropagation();
        if (onClickLeftIcon)
            onClickLeftIcon();
    };
    if (!color) {
        color = variant === PillVariant.secondary ? 'bg-gray-400' : 'bg-blue-800';
    }
    let content;
    let padding = '';
    if (LeftIcon && !RightIcon && !children) {
        content = React.createElement(LeftIcon, { "data-testid": "left-icon", className: `h-4 w-4` });
        padding = ' px-1';
    }
    else if (!LeftIcon && RightIcon && !children) {
        content = React.createElement(RightIcon, { "data-testid": "right-icon", className: `h-4 w-4` });
        padding = ' px-1';
    }
    else if (!LeftIcon && !RightIcon && children) {
        content = (React.createElement(Text, { type: TextType.custom, overrideColor: true, className: `text-xs md:text-sm font-medium flex-grow text-center w-full` }, children));
        padding = ' px-2';
    }
    else if (LeftIcon && children && !RightIcon) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", { "data-testid": "icon", className: `absolute top-0 bottom-0 inset-y-0 left-2 flex items-center justify-center${onClickLeftIcon ? ' cursor-pointer ' : ''}` },
                React.createElement(LeftIcon, { "data-testid": "left-icon", className: `${onClickLeftIcon ? 'cursor-pointer ' : ''}h-4 w-4`, onClick: handleClickLeftIcon })),
            React.createElement(Text, { type: TextType.custom, overrideColor: true, className: `text-xs md:text-sm font-medium flex-grow text-center w-full pl-8 pr-2` }, children)));
    }
    else if (!LeftIcon && children && RightIcon) {
        content = (React.createElement(React.Fragment, null,
            React.createElement(Text, { type: TextType.custom, overrideColor: true, className: `text-xs md:text-sm font-medium flex-grow text-center w-full pr-8 pl-2` }, children),
            React.createElement("span", { "data-testid": "icon", className: `absolute top-0 bottom-0 inset-y-0 right-2 flex items-center justify-center${onClickRightIcon ? ' cursor-pointer ' : ''}` },
                React.createElement(RightIcon, { "data-testid": "right-icon", className: `${onClickRightIcon ? 'cursor-pointer ' : ''}h-4 w-4`, onClick: handleClickRightIcon }))));
    }
    else if (LeftIcon && RightIcon && children) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", { "data-testid": "icon", className: `absolute top-0 bottom-0 inset-y-0 left-2 flex items-center justify-center${onClickLeftIcon ? ' cursor-pointer ' : ''}` },
                React.createElement(LeftIcon, { "data-testid": "left-icon", className: `${onClickLeftIcon ? 'cursor-pointer ' : ''}h-4 w-4`, onClick: handleClickLeftIcon })),
            React.createElement(Text, { type: TextType.custom, overrideColor: true, className: `text-xs md:text-sm font-medium flex-grow text-center w-full px-8` }, children),
            React.createElement("span", { "data-testid": "icon", className: `absolute top-0 bottom-0 inset-y-0 right-2 flex items-center justify-center${onClickRightIcon ? ' cursor-pointer ' : ''}` },
                React.createElement(RightIcon, { "data-testid": "right-icon", className: `${onClickRightIcon ? 'cursor-pointer ' : ''}h-4 w-4`, onClick: handleClickRightIcon }))));
    }
    return (React.createElement("div", { "data-testid": "pill", className: `${color} ${onClick ? 'cursor-pointer ' : ''}text-white border-0 h-5 rounded-sm text-sm relative flex flex-row items-center gap-1${padding}${appendClassProps(className)}`, onClick: onClick }, content));
};
export * from './index.types';
//# sourceMappingURL=index.js.map